<script setup lang="ts">
import { computed } from 'vue'

import Chips from '@/components/table/chips/Chips.vue'

const props = defineProps<{
  value?: number
}>()

const color = computed(() => {
  return props.value === 0.5 ? 'green' : 'black'
})
const count = computed(() => {
  if (props.value === 0.5) return 2

  return props.value
})
</script>

<template>
  <div class="preview-chip-stack">
    <Chips :color="color" :count="count" :key="value" />
  </div>
</template>

<style lang="scss" scoped>
.preview-chip-stack {
  width: 55px;
  height: calc(var(--table-chip-height) * 2.1);
  z-index: 10;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
</style>
